var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExecutionRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_4991)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_829_4991)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 211.006C192.065 211.006 244 189.465 244 162.892C244 136.319 192.065 114.778 128 114.778C63.935 114.778 12 136.319 12 162.892C12 189.465 63.935 211.006 128 211.006Z",
    fill: "url(#paint0_radial_829_4991)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M197.972 45.6389H62.1631V137.002H197.972V45.6389Z",
    fill: "url(#paint1_linear_829_4991)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.7 136.363V123.315L164.013 116.784L197.966 136.363V149.418L186.646 155.942L152.7 136.363Z",
    fill: "url(#paint2_linear_829_4991)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.7 123.315L186.646 142.887V155.942L152.7 136.363V123.315Z",
    fill: "#8060EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.646 142.887L197.966 136.363V149.418L186.646 155.942V142.887Z",
    fill: "#570EE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.061 142.887V129.839L141.381 123.315L175.333 142.887V155.942L164.013 162.466L130.061 142.887Z",
    fill: "url(#paint3_linear_829_4991)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.061 129.839L164.013 149.418V162.466L130.061 142.887V129.839Z",
    fill: "#8060EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.013 149.418L175.333 142.887V155.942L164.013 162.466V149.418Z",
    fill: "#570EE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 149.418L96.1089 129.839L107.429 136.363V149.418L73.4762 168.997L62.1631 162.466V149.418Z",
    fill: "#570EE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 149.418L73.4762 155.942V168.997L62.1631 162.466V149.418Z",
    fill: "#8060EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 149.418L96.1089 129.839L107.429 136.363L73.4762 155.942L62.1631 149.418Z",
    fill: "#B7A4F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4761 155.942L107.428 136.363L118.748 142.887V155.942L84.7957 175.521L73.4761 168.997V155.942Z",
    fill: "#570EE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4761 155.942L84.7957 162.466V175.521L73.4761 168.997V155.942Z",
    fill: "#8060EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4761 155.942L107.428 136.363L118.748 142.887L84.7957 162.466L73.4761 155.942Z",
    fill: "url(#paint4_linear_829_4991)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 162.466L118.748 142.887L130.061 149.418V162.466L96.1085 182.045L84.7954 175.521V162.466Z",
    fill: "#570EE5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 162.466L96.1085 168.997V182.045L84.7954 175.521V162.466Z",
    fill: "#8060EA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 162.466L118.748 142.887L130.061 149.418L96.1085 168.997L84.7954 162.466Z",
    fill: "#B7A4F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 136.363L96.1089 116.784L107.429 123.315V136.363L73.4762 155.942L62.1631 149.418V136.363Z",
    fill: "#570EE5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 136.363L73.4762 142.887V155.942L62.1631 149.418V136.363Z",
    fill: "#8060EA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 136.363L96.1089 116.784L107.429 123.315L73.4762 142.887L62.1631 136.363Z",
    fill: "#B7A4F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 149.418L118.748 129.839L130.061 136.363V149.418L96.1085 168.997L84.7954 162.466V149.418Z",
    fill: "#570EE5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 149.418L96.1085 155.942V168.997L84.7954 162.466V149.418Z",
    fill: "#8060EA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 149.418L118.748 129.839L130.061 136.363L96.1085 155.942L84.7954 149.418Z",
    fill: "url(#paint5_linear_829_4991)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4761 129.839V116.784L84.7957 110.26L118.748 129.839V142.887L107.428 149.418L73.4761 129.839Z",
    fill: "#B7A4F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4761 116.784L107.428 136.363V149.418L73.4761 129.839V116.784Z",
    fill: "#8060EA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.428 136.363L118.748 129.839V142.887L107.428 149.418V136.363Z",
    fill: "#570EE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 136.363V123.315L73.4762 116.784L107.429 136.363V149.418L96.1089 155.942L62.1631 136.363Z",
    fill: "url(#paint6_linear_829_4991)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 123.315L96.1089 142.887V155.942L62.1631 136.363V123.315Z",
    fill: "#8060EA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1089 142.887L107.428 136.363V149.418L96.1089 155.942V142.887Z",
    fill: "#570EE5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4761 116.785L107.428 97.2057L118.748 103.736V116.785L84.7957 136.363L73.4761 129.839V116.785Z",
    fill: "#570EE5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4761 116.784L84.7957 123.315V136.363L73.4761 129.839V116.784Z",
    fill: "#8060EA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4761 116.785L107.428 97.2057L118.748 103.736L84.7957 123.315L73.4761 116.785Z",
    fill: "url(#paint7_linear_829_4991)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 123.315L118.748 103.736L130.061 110.26V123.315L96.1085 142.887L84.7954 136.363V123.315Z",
    fill: "#570EE5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 123.315L96.1085 129.839V142.887L84.7954 136.363V123.315Z",
    fill: "#8060EA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7954 123.315L118.748 103.736L130.061 110.26L96.1085 129.839L84.7954 123.315Z",
    fill: "url(#paint8_linear_829_4991)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3711 104.369V91.3205L83.6907 84.7899L117.643 104.369V117.423L106.323 123.947L72.3711 104.369Z",
    fill: "url(#paint9_linear_829_4991)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3711 91.3205L106.323 110.899V123.947L72.3711 104.369V91.3205Z",
    fill: "#8060EA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M106.324 110.899L117.643 104.369V117.423L106.324 123.947V110.899Z",
    fill: "#570EE5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M141.381 133.104L175.333 113.526L186.646 120.05V133.104L152.7 152.683L141.381 146.153V133.104Z",
    fill: "#570EE5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M141.381 133.104L152.7 139.629V152.683L141.381 146.153V133.104Z",
    fill: "#8060EA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M141.381 133.104L175.333 113.526L186.646 120.05L152.7 139.628L141.381 133.104Z",
    fill: "url(#paint10_linear_829_4991)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    d: "M169.68 45H124.408V172.255H169.68V45Z",
    fill: "url(#paint11_linear_829_4991)"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M124.401 172.255L158.354 152.683L169.673 159.207V172.255L135.721 191.834L124.401 185.31V172.255Z",
    fill: "#570EE5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M124.401 172.255L135.721 178.786V191.834L124.401 185.31V172.255Z",
    fill: "#8060EA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M124.401 172.255L158.354 152.683L169.673 159.207L135.721 178.786L124.401 172.255Z",
    fill: "url(#paint12_linear_829_4991)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_829_4991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.855 162.873) scale(115.833 48.0969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8060EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8060EA",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8060EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_829_4991",
    x1: 130.061,
    y1: 137.002,
    x2: 130.061,
    y2: 45.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CD385",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#90DA97",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3E0A9",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B3E5B8",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#BEE9C2",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C5EBC8",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C7ECCA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_829_4991",
    x1: 152.7,
    y1: 136.363,
    x2: 197.966,
    y2: 136.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_829_4991",
    x1: 135.721,
    y1: 152.683,
    x2: 169.653,
    y2: 133.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_829_4991",
    x1: 73.4761,
    y1: 149.418,
    x2: 118.748,
    y2: 149.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_829_4991",
    x1: 84.7954,
    y1: 142.894,
    x2: 130.061,
    y2: 142.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_829_4991",
    x1: 67.8164,
    y1: 146.153,
    x2: 101.748,
    y2: 126.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_829_4991",
    x1: 73.4761,
    y1: 110.26,
    x2: 118.748,
    y2: 110.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_829_4991",
    x1: 84.7954,
    y1: 116.784,
    x2: 130.061,
    y2: 116.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_829_4991",
    x1: 78.0309,
    y1: 114.158,
    x2: 111.963,
    y2: 94.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_829_4991",
    x1: 141.381,
    y1: 126.574,
    x2: 186.646,
    y2: 126.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_829_4991",
    x1: 147.04,
    y1: 172.255,
    x2: 147.04,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7ECCA",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C7ECCA",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C7ECCA",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C7ECCA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C7ECCA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C7ECCA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_829_4991",
    x1: 124.408,
    y1: 165.731,
    x2: 169.673,
    y2: 165.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#78D7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6CCFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B399FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_4991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 208,
    fill: "white",
    transform: "translate(24 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_829_4991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 166,
    fill: "white",
    transform: "translate(12 45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutionRisk);
export default __webpack_public_path__ + "static/media/execution_risk.662e9726e70b0a27d359089d35b54d3e.svg";
export { ForwardRef as ReactComponent };